import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { RootState } from 'src/store';
import { IMenuState } from 'src/store/slices/index';
import { LinkSvg } from 'src/assets/index';
import './style.scss';

interface IMapStateToProps {
  menuStore: IMenuState;
  isGetawaysListPage: boolean;
}

interface IProps extends IMapStateToProps {}

const ZERO = 0;

class FooterComponent extends React.Component<IProps, null> {
  render(): React.ReactNode {
    const { menuStore, isGetawaysListPage } = this.props;
    const { items, loading } = menuStore;

    return menuStore.error.length === ZERO && !loading ? (
      <div className={`footer ${isGetawaysListPage ? 'footer__blue' : ''} footer__print`}>
        {items?.essentials ? (
          <div className="footer__trip-useful-wrapper">
            <div className="footer__trip">
              <p className="footer__title">
                <FormattedMessage id="trip.essentials" />
              </p>
              <div className="footer__trip-wrapper">
                {items?.essentials.map((item, index) => (
                  <div className="footer__trip-navigation" key={`${item.title}-${index}`}>
                    <a
                      className="footer__trip-link-nav"
                      href={item.url}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {item.title}
                      <LinkSvg />
                    </a>
                  </div>
                ))}
              </div>
            </div>
            <div className="footer__useful">
              <p className="footer__title">
                <FormattedMessage id="useful.information" />
              </p>
              <div className="footer__useful-wrapper">
                {items?.useful.map((item, index) => (
                  <div className="footer__userful-navigation" key={`${item.title}-${index}`}>
                    {item.isPopup ? (
                      <a
                        className="footer__userful-link-nav"
                        href={item.url}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {item.title}
                        <LinkSvg />
                      </a>
                    ) : (
                      <Link className="footer__userful-link-nav" to={item.url}>
                        {item.title}
                      </Link>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        ) : null}
        {items?.footer ? (
          <div className="footer__footer">
            {items?.footer.map((item, index) => (
              <div className="footer__navigation" key={`${item.title}-${index}`}>
                <a className="footer__link-nav" href={item.url}>
                  {item.title}
                </a>
              </div>
            ))}
          </div>
        ) : null}
      </div>
    ) : null;
  }
}

const mapStateToProps = (state: RootState): IMapStateToProps => {
  return {
    menuStore: state.navigationMenuStore,
    isGetawaysListPage: state.getawaysStore.isGetawaysListPage,
  };
};

export const Footer = connect(mapStateToProps, null)(FooterComponent);

